import PropTypes from 'prop-types';
import React from 'react';

function Text(props) {
  const { fill } = props;

  return (
    <svg
      height={24}
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 5.26667V4.70151C3.9998 4.47814 4.04399 4.25691 4.13006 4.05049C4.21612 3.84406 4.34236 3.65647 4.50156 3.49845C4.66077 3.34043 4.84982 3.21508 5.05791 3.12955C5.26599 3.04402 5.48903 3 5.71429 3H18.2857C18.511 3 18.734 3.04402 18.9421 3.12955C19.1502 3.21508 19.3392 3.34043 19.4984 3.49845C19.6576 3.65647 19.7839 3.84406 19.8699 4.05049C19.956 4.25691 20.0002 4.47814 20 4.70151V5.26818"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path d="M12 3V20" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      <path
        d="M8.57129 19.9995H15.4284"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Text.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Text;
